@if (usuario && usuario.isAdmin) {
  <li class="nav-item dropdown">
    <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
      Administrar
    </a>

    <div class="dropdown-menu">
      <a class="dropdown-item" [routerLink]="['/adm/home']">Home</a>
      <a class="dropdown-item" [routerLink]="['/adm/link']">Links</a>
      <a class="dropdown-item" [routerLink]="['/adm/tema']">Temas</a>
      <a class="dropdown-item" [routerLink]="['/adm/materia']">Artigos</a>
      <a class="dropdown-item" [routerLink]="['/adm/exercicio']">Exercícios</a>
      <a class="dropdown-item" [routerLink]="['/adm/cinema']">Cinema</a>
      <a class="dropdown-item" [routerLink]="['/adm/abdominal']">Abdominais</a>
      <a class="dropdown-item" [routerLink]="['/adm/cardio']">Cardio</a>
      <a class="dropdown-item" [routerLink]="['/adm/volei-protocol']">Protocolo Volei</a>

      <div class="dropdown-divider"></div>

      <a class="dropdown-item" role="button" (click)="logout()">
        Sair
      </a>
    </div>
  </li>
}